const getters = {
  token: state => state.user.token,
  enrollState: state => state.user.enrollState,
  landPageRoute: state => state.user.landPageRoute,
  userName: state => state.user.userName,
  realName: state => state.user.realName,
  headUrl: state => state.user.headUrl,
  phone: state => state.user.phone,
  openId: state => state.user.openId,
  mpOpenId: state => state.user.mpOpenId,
  unionId: state => state.user.unionId,
  status: state => state.user.status,
  role: state => state.user.role,


  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,


}
export default getters
